/* eslint-disable react/jsx-no-target-blank */
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import FavoriteIcon from "@mui/icons-material/Favorite";

import { giftInfo } from "Routes/constants";

import { ReactComponent as GiftCityICon } from "assets/images/svg/logo-dark.svg";
import { ReactComponent as TwitterIcon } from "assets/images/svg/Twitter.svg";
import { ReactComponent as YouTubeIcon } from "assets/images/svg/Youtube.svg";
import { ReactComponent as LinkdinIcon } from "assets/images/svg/LinkedIn.svg";
import { ReactComponent as AppStoreQr } from "assets/images/appstore-qr.svg";
import { ReactComponent as PlayStoreQr } from "assets/images/playstore-qr.svg";
import AppStore from "assets/images/app-store.png";
import PlayStore from "assets/images/play-store.png";

const FooterSection = ({ menuItems = [], isGiftInfo }) => {
  const navigate = useNavigate();

  const footerItems = useMemo(
    () => menuItems.filter(({ isHeader }) => !isHeader),
    [menuItems]
  );

  return (
    <section
      className="footer-section"
      style={isGiftInfo ? { width: "100%" } : {}}
    >
      <div className="container-fluid">
        <div className="d-flex justify-content-center gap-5 align-items-center footer-wrapper">
          <div className="d-flex me-4 gap-5">
            <div>
              {footerItems.map(
                ({ name, id }, index) =>
                  Math.ceil(footerItems.length / 2) > index && (
                    <p
                      className="regular-font text-white link-wrapper mb-0"
                      key={index}
                    >
                      <p
                        className="cursor-pointer medium-font link-text regular-font text-white link-wrapper mb-0"
                        onClick={() => {
                          navigate(giftInfo, {
                            state: {
                              id,
                            },
                          });
                        }}
                      >
                        {name}
                      </p>
                    </p>
                  )
              )}
            </div>
            <div>
              {footerItems.map(
                ({ name, id }, index) =>
                  Math.ceil(footerItems.length / 2) < index + 1 && (
                    <p
                      className="regular-font text-white link-wrapper mb-0"
                      key={index}
                    >
                      <p
                        className="cursor-pointer medium-font link-text regular-font text-white link-wrapper mb-0"
                        onClick={() => {
                          navigate(giftInfo, {
                            state: {
                              id,
                            },
                          });
                        }}
                      >
                        {name}
                      </p>
                    </p>
                  )
              )}
            </div>
          </div>
          <div className="right-wrapper">
            <div className="footer-logo">
              <GiftCityICon />
            </div>
            <div className="text regular-font semibold-font pb-2">
              <p>
                © 2023 GIFT City - All intellectual property rights reserved
              </p>
            </div>
            <div className="logo-wrapper d-flex justify-content-between">
              <a href="#">
                <TwitterIcon style={{ maxHeight: "50px", maxWidth: "50px" }} />
              </a>
              <a href="#">
                <YouTubeIcon style={{ maxHeight: "50px", maxWidth: "50px" }} />
              </a>
              <a href="#">
                <LinkdinIcon style={{ maxHeight: "50px", maxWidth: "50px" }} />
              </a>
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center justify-content-center gap-4">
            <div className="d-flex flex-column align-items-center justify-content-center">
              <AppStoreQr style={{ backgroundColor: "#fff", padding: "1px" }} />
              <a
                className="mt-3 cursor-pointer"
                href="https://apps.apple.com/in/app/gift-utilities/id6711337163"
                target="_blank"
              >
                <img src={AppStore} width={150} />
              </a>
            </div>
            <div className="d-flex flex-column align-items-center justify-content-center">
              <PlayStoreQr
                style={{ backgroundColor: "#fff", padding: "1px" }}
              />
              <a
                className="mt-3 cursor-pointer"
                href="https://play.google.com/store/apps/details?id=com.giftutilities"
                target="_blank"
              >
                <img src={PlayStore} width={150} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-wrapper d-flex justify-content-center mt-3 text-white company-name">
        Designed & Developed with&nbsp;
        <FavoriteIcon
          style={{ fontSize: "17px", marginTop: "2px" }}
          color="error"
        />
        &nbsp;By&nbsp;
        <a
          className="text-white"
          href="https://www.bigscal.com/"
          target="_blank"
        >
          <span
            style={{
              textDecoration: "underline",
            }}
          >
            Bigscal Technologies Pvt. Ltd.
          </span>
        </a>
      </div>
    </section>
  );
};

export default FooterSection;

FooterSection.propTypes = {
  menuItems: PropTypes.array,
  isGiftInfo: PropTypes.bool,
};
